import React, {useContext} from 'react'
import {RULE_STATUS, SHIPPING_BOX_TYPE} from "../../helpers/options"
import SettingShippingCarrierContext from '../context/SettingShippingCarrierContext'
import FilterOptions from "../../../components/InputSelect/FilterOptions"
import { Select } from 'antd'

const SettingShippingCarrierFilters = (props) => {
    const {optionsCarrier, optionsBoxName} = props
    const {filters, setState} = useContext(SettingShippingCarrierContext)

    const _handleChangeFilterState = (paramFilter) => {
        const _filters = {
            ...filters,
            ...paramFilter
        }
        
        if(Object.values(paramFilter)[0] === '') delete _filters[Object.keys(paramFilter)[0]]
        setState(_filters)
    }

    const optionsSelect = [];
    for (let i = 10; i < 36; i++) {
        optionsSelect.push({
            label: i.toString(36) + i,
            value: i.toString(36) + i,
        });
    }

    const handleChange = (name, value) => {
        const paramFilter = {
            [name]: value
        }
        const _filters = {
            ...filters,
            ...paramFilter
        }

        if(Object.values(paramFilter)[0].length === 0) delete _filters[Object.keys(paramFilter)[0]]
        setState(_filters)
    };

    return (
        <div className="d-flex flex-wrap">
            <div className="itemFilterGroup mb-3 mr-3">
                {/* <label className="mb-1 Heading">Store</label> */}
                {/* <SearchGroup options={options} onSearch={_handleChangeFilterGroupState}/> */}

                <Select
                mode="multiple"
                allowClear
                style={{ width: '350px' }}
                placeholder="Search: Slug, Shipping carrier, Original carrier"
                filterOption={(input, option) => (option?.name.toLowerCase() ?? '').includes(input.toLowerCase())}
                onChange={value => handleChange('carriers', value)}
                options={optionsCarrier}
                value={filters.carriers}
                />
            </div>
            <div className="itemFilterGroup mb-3 mr-3">
                {/* <label className="mb-1 Heading">Store</label> */}
                {/* <SearchGroup options={options} onSearch={_handleChangeFilterGroupState}/> */}

                <Select
                mode="multiple"
                allowClear
                style={{ width: '350px' }}
                placeholder="Search for box name"
                filterOption={(input, option) => (option?.name.toLowerCase() ?? '').includes(input.toLowerCase())}
                onChange={value => handleChange('box_names', value)}
                options={optionsBoxName}
                value={filters.box_names}
                />
            </div>
            {/* <div className="itemFilterGroup mb-3 mr-3">
                <Select
                mode="multiple"
                allowClear
                style={{ width: '350px' }}
                placeholder="Search for combination box"
                filterOption={(input, option) => (option?.name.toLowerCase() ?? '').includes(input.toLowerCase())}
                onChange={value => handleChange('combination_boxes', value)}
                options={optionsCombinationBox}
                value={filters.combination_boxes}
                />
            </div> */}
            <div className="itemFilter mr-3 mb-3">
                <FilterOptions onChangeOption={_handleChangeFilterState} selectedKey={filters.original_carrier_status || ''} field='original_carrier_status'
                               placeHolder="Original carrier status"
                               options={RULE_STATUS} layout='select' heading='' defaultOption={''}
                               allowClear={true}/>
            </div>
            <div className="itemFilter mr-3 mb-3">
                <FilterOptions onChangeOption={_handleChangeFilterState} selectedKey={filters.label_generation_status || ''} field='label_generation_status'
                               placeHolder="Label generation status"
                               options={RULE_STATUS} layout='select' heading='' defaultOption={''}
                               allowClear={true}/>
            </div>
            <div className="itemFilter mr-3 mb-3">
                <FilterOptions onChangeOption={_handleChangeFilterState} selectedKey={filters.box_type || ''} field='box_type'
                               placeHolder="Shipping box type"
                               options={SHIPPING_BOX_TYPE} layout='select' heading='' defaultOption={''}
                               allowClear={true}/>
            </div>
        </div>
    )
}

export default SettingShippingCarrierFilters
